var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bravado-typeform-steps"},[_c('div',{staticClass:"bravado-typeform-steps__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"bravado-typeform-steps__subtitle"},[_vm._v(_vm._s(`Step ${_vm.stepNumber} of ${_vm.stepsAmount}`))])])
}
var staticRenderFns = []

export { render, staticRenderFns }